// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { BASE_ENV } from './environment.base';

// Define all environment configs
const ENV_CONFIGS = {
  DEV: {
    name: 'DEV',
    dbVersion: 11,
    production: false,
    type: 'DEV',
    firebaseConfig: {
      apiKey: 'AIzaSyBWhuqQvHEjNi2s07R7vfVjjcLCTGn_Nh8',
      authDomain: 'care4giver-app.firebaseapp.com',
      databaseURL: 'https://care4giver-app.firebaseio.com',
      projectId: 'care4giver-app',
      storageBucket: 'care4giver-app.appspot.com',
      messagingSenderId: '441623843943',
      appId: '1:441623843943:web:ee85c5019b708848efb0c2',
      measurementId: 'G-7BBLKT7Q5W',
    },
    vapidKey: 'BJmVNPgGDP4CnovQjz7NXlvtX0FAtE3sJ-ZDP6qvW6C5f4ViqZEPKeBZtjIcOGItr2DFjgZHrpiDAoaLm3rlQoM',
    fbCloud:
      'AAAAZtLVFGc:APA91bHLltpUNyXJK97Ef8A20NpMSC3rC--Z83-cexvan2BRHl7uvTc8TSA_HIaifncz-B5X_muYtyhAXtGyBVdivImPbvSpuvgg8AgHUXEMDbW4hFa0u74CRRWQ3YEDHjmT_N16jiIl',
    api: 'http://192.168.1.87:3000/',
    client: 'http://localhost:4201/',
    csLogin: 'http://localhost:4400/login',
    cgLogin: 'http://localhost:4200/login',
    cmstoken: 'af1b3966b757e3a6c29be9afa5ec583b2499d33c',
    stripe: 'pk_test_OocrQmulntS8pZwq7uNXVBpe00OpxKb2gr',
    pusher: {
      key: '5d447265bb5235cd1881',
      cluster: 'us2',
    },
  },
  PROD: {
    name: 'PROD',
    dbVersion: 11,
    production: true,
    type: 'PROD',
    firebaseConfig: {
      apiKey: 'AIzaSyD6aZ6jnHI65t1lPbHa4zpLjg-s8t1N5Uo',
      authDomain: 'care4giver-app-prod.firebaseapp.com',
      projectId: 'care4giver-app-prod',
      storageBucket: 'care4giver-app-prod.appspot.com',
      messagingSenderId: '633163859830',
      appId: '1:633163859830:web:4b85cdd3c4e34f7b595c57',
      measurementId: 'G-3PDFMJQEY7',
    },
    vapidKey: 'BJ1_W_qZObM4EkSHIqIe-740aDLWXU-3Xj7VRe8v_BLw2jMZWK51OHrJNvM3kqqFmDkF3acuTHE3-gatSdjmsJU',
    api: 'https://prod-api-v2-umcl27v3ta-ue.a.run.app/',
    client: 'https://caregivers.care4giver.com/',
    csLogin: ' https://careseekers.care4giver.com/login',
    cgLogin: 'https://caregivers.care4giver.com/login',
    cmstoken: 'af1b3966b757e3a6c29be9afa5ec583b2499d33c',
    stripe: 'pk_test_OocrQmulntS8pZwq7uNXVBpe00OpxKb2gr',
    pusher: {
      key: '40523aff440afdb5933e',
      cluster: 'us2',
    },
  },
  STAGING: {
    name: 'STAGING',
    dbVersion: 11,
    production: false,
    type: 'STAGING',
    firebaseConfig: {
      apiKey: 'AIzaSyBWhuqQvHEjNi2s07R7vfVjjcLCTGn_Nh8',
      authDomain: 'care4giver-app.firebaseapp.com',
      databaseURL: 'https://care4giver-app.firebaseio.com',
      projectId: 'care4giver-app',
      storageBucket: 'care4giver-app.appspot.com',
      messagingSenderId: '441623843943',
      appId: '1:441623843943:web:ee85c5019b708848efb0c2',
      measurementId: 'G-7BBLKT7Q5W',
    },
    fbCloud:
      'AAAAZtLVFGc:APA91bHLltpUNyXJK97Ef8A20NpMSC3rC--Z83-cexvan2BRHl7uvTc8TSA_HIaifncz-B5X_muYtyhAXtGyBVdivImPbvSpuvgg8AgHUXEMDbW4hFa0u74CRRWQ3YEDHjmT_N16jiIl',
    vapidKey: 'BJmVNPgGDP4CnovQjz7NXlvtX0FAtE3sJ-ZDP6qvW6C5f4ViqZEPKeBZtjIcOGItr2DFjgZHrpiDAoaLm3rlQoM',
    api: 'https://webhook-umcl27v3ta-ue.a.run.app/',
    client: 'https://caregivers.staging.care4giver.com/',
    csLogin: 'https://careseeker-app.web.app/login',
    cgLogin: 'https://caregivers.staging.care4giver.com/login',
    cmstoken: 'af1b3966b757e3a6c29be9afa5ec583b2499d33c',
    stripe: 'pk_test_OocrQmulntS8pZwq7uNXVBpe00OpxKb2gr',
    pusher: {
      key: '5d447265bb5235cd1881',
      cluster: 'us2',
    },
  },
  FAKEPROD: {
    name: 'FAKEPROD',
    dbVersion: 11,
    production: true,
    type: 'DEV',
    firebaseConfig: {
      apiKey: 'AIzaSyD6aZ6jnHI65t1lPbHa4zpLjg-s8t1N5Uo',
      authDomain: 'care4giver-app-prod.firebaseapp.com',
      projectId: 'care4giver-app-prod',
      storageBucket: 'care4giver-app-prod.appspot.com',
      messagingSenderId: '633163859830',
      appId: '1:633163859830:web:4b85cdd3c4e34f7b595c57',
      measurementId: 'G-3PDFMJQEY7',
    },
    api: 'http://localhost:3000/',
    client: 'http://localhost:4201/',
    csLogin: 'http://localhost:4400/login',
    cgLogin: 'http://localhost:4200/login',
    cmstoken: 'af1b3966b757e3a6c29be9afa5ec583b2499d33c',
    stripe: 'pk_test_OocrQmulntS8pZwq7uNXVBpe00OpxKb2gr',
    pusher: {
      key: '5d447265bb5235cd1881',
      cluster: 'us2',
    },
    vapidKey: 'BJ1_W_qZObM4EkSHIqIe-740aDLWXU-3Xj7VRe8v_BLw2jMZWK51OHrJNvM3kqqFmDkF3acuTHE3-gatSdjmsJU',
  },
};

// Set initial environment based on BASE_ENV or localStorage
let storedEnv: string | null = null;
if (typeof window !== 'undefined') {
  try {
    storedEnv = localStorage.getItem('c4g-env');
  } catch (e) {
    console.warn('[env] Could not access localStorage:', e);
  }
}
let currentEnv: keyof typeof ENV_CONFIGS;
if (storedEnv && Object.prototype.hasOwnProperty.call(ENV_CONFIGS, storedEnv)) {
  currentEnv = storedEnv as keyof typeof ENV_CONFIGS;
  console.log('[env] Loaded environment from localStorage:', currentEnv);
} else {
  if (storedEnv) {
    console.warn('[env] Invalid environment in localStorage:', storedEnv, 'Falling back to BASE_ENV:', BASE_ENV);
  }
  currentEnv = BASE_ENV as keyof typeof ENV_CONFIGS;
}
export let environment = ENV_CONFIGS[currentEnv];
const originalEnvironment = ENV_CONFIGS[BASE_ENV as keyof typeof ENV_CONFIGS];
console.log('[env] Using environment:', currentEnv, environment);

export { ENV_CONFIGS, currentEnv, BASE_ENV, originalEnvironment };

export function getEnv() {
  return environment;
}

export function setEnv(envName: string) {
  const found = Object.values(ENV_CONFIGS).find(cfg => cfg.name === envName);
  if (found) {
    environment = found;
    currentEnv = found.name as keyof typeof ENV_CONFIGS;
    if (typeof window !== 'undefined') {
      localStorage.setItem('c4g-env', found.name);
      window.location.reload();
    }
  } else {
    throw new Error(`Unknown environment: ${envName}`);
  }
}

export function resetEnv() {
  environment = originalEnvironment;
  currentEnv = BASE_ENV as keyof typeof ENV_CONFIGS;
  if (typeof window !== 'undefined') {
    localStorage.removeItem('c4g-env');
    window.location.reload();
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
